export function initLawyer(form = {}) {
    return {
        ...(form || {}),

        name: form?.name || null,
        rank: form?.rank || null,
        phone: form?.phone || null,
        email: form?.email || null,
        index: form?.index ?? 999,

        image: form?.image || null,
        about: form?.about || null,

        section1: {
            ...(form?.section1 || {}),
            txt: form?.section1?.txt || null,
        },

        section2: [...(form?.section2 || [{}])].map(initLawyerSection2),

        section3: [...(form?.section3 || [{}])].map(initLawyerSection3),

        section4: [...(form?.section4 || [{}])].map(initLawyerSection4),

        section5: [...(form?.section5 || [{}])].map(initLawyerSection5),

        code: form?.code || null,
        local: form?.local || "ko",
    };
}

export function initLawyerSection2(form = {}) {
    return {
        ...(form || {}),

        title: form?.title || null,
        columns: [...(form?.columns || [{}])].map((item) => ({
            ...(item || {}),
            txt: item?.txt || null,
        })),
    };
}

export function initLawyerSection3(form = {}) {
    return {
        ...(form || {}),

        title: form?.title || null,
        txt: form?.txt || null,
    };
}

export const initLawyerSection4 = initLawyerSection3;

export function initLawyerSection5(form = {}) {
    return {
        ...(form || {}),

        title: form?.title || null,

        columns: [...(form?.columns || [{}])].map((item) => ({
            ...(item || {}),
            title: item?.title || null,
            txt: item?.txt || null,
        })),
    };
}
